import { useCallback } from 'react';
import { Alert, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import { useAppContext } from '@/context';
import { ConnectedAccountsPanel } from './AccountSecurityPanels';
import { useProfileResource } from './profileRequests';

export default function SocialAccountsSection() {
  const { apiClients } = useAppContext();
  const load = useCallback(() => apiClients.users.usersProfileSocialAccountsRetrieve(), [apiClients.users]);
  const { data, loading, error, retry } = useProfileResource(load, 'Could not load connected accounts. Please retry.');
  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h6" component="h2">
            Connected Accounts
          </Typography>
          {loading && <CircularProgress aria-label="Loading connected accounts" />}
          {error && (
            <Alert
              severity="error"
              action={
                <Button color="inherit" onClick={retry}>
                  Retry
                </Button>
              }
            >
              {error}
            </Alert>
          )}
          {data && <ConnectedAccountsPanel data={data} />}
        </Stack>
      </CardContent>
    </Card>
  );
}
